// src/components/Layout/Navbar.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/images/branding-vanguard-navbar6.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Hamburger Icon - Left side on mobile */}
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={isOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </div>

        {/* Navigation Menu - Hidden on desktop, shows on mobile when hamburger clicked */}
        <ul className={isOpen ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={closeMenu}>
              HOME
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/what-we-do" className="nav-link" onClick={closeMenu}>
              WHAT WE DO
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/people-career" className="nav-link" onClick={closeMenu}>
              PEOPLE CAREER
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact-us" className="nav-link" onClick={closeMenu}>
              CONTACT US
            </Link>
          </li>
        </ul>

        {/* Logo - Right side */}
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src={logo} alt="Vanguard Facility Services Group" className="logo-image" />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;